const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410327104',
            ext_path: '河南省 洛阳市 宜阳县 白杨镇',
            cid: '1',
            pid: '410327',
            name: '白杨镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.197295, 34.381328]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327100',
            ext_path: '河南省 洛阳市 宜阳县 城关镇',
            cid: '2',
            pid: '410327',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.174281, 34.513316]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327212',
            ext_path: '河南省 洛阳市 宜阳县 董王庄乡',
            cid: '3',
            pid: '410327',
            name: '董王庄乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.101472, 34.350745]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327111',
            ext_path: '河南省 洛阳市 宜阳县 樊村镇',
            cid: '4',
            pid: '410327',
            name: '樊村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.247136, 34.468019]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327112',
            ext_path: '河南省 洛阳市 宜阳县 高村乡',
            cid: '5',
            pid: '410327',
            name: '高村乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.856876, 34.565644]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327103',
            ext_path: '河南省 洛阳市 宜阳县 韩城镇',
            cid: '6',
            pid: '410327',
            name: '韩城镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.92742, 34.513657]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327208',
            ext_path: '河南省 洛阳市 宜阳县 花果山乡',
            cid: '7',
            pid: '410327',
            name: '花果山乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.880013, 34.325644]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327106',
            ext_path: '河南省 洛阳市 宜阳县 锦屏镇',
            cid: '8',
            pid: '410327',
            name: '锦屏镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.183717, 34.494547]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327109',
            ext_path: '河南省 洛阳市 宜阳县 莲庄镇',
            cid: '9',
            pid: '410327',
            name: '莲庄镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.003752, 34.470586]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327102',
            ext_path: '河南省 洛阳市 宜阳县 柳泉镇',
            cid: '10',
            pid: '410327',
            name: '柳泉镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.031945, 34.547418]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327107',
            ext_path: '河南省 洛阳市 宜阳县 三乡镇',
            cid: '11',
            pid: '410327',
            name: '三乡镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.810754, 34.464059]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327209',
            ext_path: '河南省 洛阳市 宜阳县 上观乡',
            cid: '12',
            pid: '410327',
            name: '上观乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.959331, 34.388903]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327105',
            ext_path: '河南省 洛阳市 宜阳县 香鹿山镇',
            cid: '13',
            pid: '410327',
            name: '香鹿山镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.209666, 34.574598]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327203',
            ext_path: '河南省 洛阳市 宜阳县 盐镇乡',
            cid: '14',
            pid: '410327',
            name: '盐镇乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.045484, 34.620339]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327108',
            ext_path: '河南省 洛阳市 宜阳县 张坞镇',
            cid: '15',
            pid: '410327',
            name: '张坞镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.83141, 34.396759]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410327110',
            ext_path: '河南省 洛阳市 宜阳县 赵保镇',
            cid: '16',
            pid: '410327',
            name: '赵保镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.0947, 34.42941]
        }
    }
];

export { d };
